module.exports = __webpack_public_path__ + "static/media/nutricia-product-scoop-chart-2024-august-uk.bb7f278c.pdf";